import Layout from "@/components/feature/Layout";
import ServicePage from "@/components/feature/ServicePage";

const data = {
  heroTitle: "Halı yıkama hizmeti",
  heroDescription: "Adana halı yıkama hizmetiyle halılarınızı ilk günkü temizliğine yaklaştıran profesyonel çözümler.",
  description: "Halılar, toz ve kirin en çok biriktiği alanlardan biridir. Day Temizlik Adana, halı yıkama hizmetinde halının yapısına uygun temizlik süreciyle hijyenik, ferah ve temiz sonuçlar hedefler. Uygun ekipman ve dikkatli uygulama ile halılarınızı derinlemesine temizliyoruz.",
  scope: [
    "Halı toz alma",
    "Yıkama ve durulama süreci",
    "Leke odaklı temizlik",
    "Koku oluşumunu azaltmaya yönelik temizlik",
    "Teslimat ve kullanım öncesi kontrol alanı",
  ],
  forWho: [
    "Ev sahipleri",
    "Kiracılar",
    "Ofis ve iş yeri sahipleri",
    "Otel ve konaklama işletmeleri",
    "Camiler ve ibadethaneler",
  ],
  process: [
    "Halının yapısı, malzemesi ve kir yoğunluğunu değerlendiriyoruz.",
    "Toz alma ve ön hazırlık işlemlerini uyguluyoruz.",
    "Yıkama ve durulama sürecini yapısına uygun şekilde gerçekleştiriyoruz.",
    "Leke odaklı temizlik uyguluyoruz.",
    "Kuruma ve kontrol sonrası size teslim ediyoruz.",
  ],
  whyProfessional: [
    "Profesyonel yıkama halı yapısına zarar vermeden derinlemesine temizlik sağlar.",
    "Leke ve koku oluşumuna karşı daha etkili çözümler sunulur.",
    "Uygun durulama sayesinde kalıntı kalmaz.",
    "Halılarınızın ömrü ve görünümü korunur.",
    "Hijyenik sonuçlarla yaşam alanlarınız daha sağlıklı hale gelir.",
  ],
  relatedServices: [
    { title: "Koltuk Yıkama", path: "/hizmetlerimiz/koltuk-yikama" },
    { title: "Daire Temizliği", path: "/hizmetlerimiz/daire-temizligi" },
    { title: "Kuru Temizleme ve Ütü", path: "/hizmetlerimiz/kuru-temizleme-ve-utu" },
  ],
  faqs: [
    { question: "Halı yıkama süreci nasıl ilerler?", answer: "Halı toz alma, yıkama ve durulama, leke odaklı temizlik, koku giderici işlemler ve teslimat öncesi kontrol aşamalarından oluşur." },
    { question: "Halı yıkama ne kadar sürer?", answer: "Halı boyutuna ve yoğunluğuna göre değişir. Genellikle 1-3 gün içinde teslim edilir." },
    { question: "Halıların teslim alınması nasıl olur?", answer: "Adresinizden alınan halılar, temizlendikten sonra aynı adrese teslim edilir." },
  ],
  ctaText: "Halılarınız için profesyonel yıkama hizmeti alın.",
  heroImage: "/assets/images/hali-yikama.jpg",
};

export default function HaliYikamaPage() {
  return (
    <Layout>
      <ServicePage data={data} />
    </Layout>
  );
}